// Utility function to update sitemap when a new blog is created
export const updateSitemap = async () => {
  try {
    // In development, skip sitemap update (Netlify functions not available)
    if (process.env.NODE_ENV === 'development') {
      console.log('Sitemap update skipped in development mode');
      return true;
    }
    
    // Determine the base URL based on environment
    const baseUrl = process.env.NODE_ENV === 'production' 
      ? 'https://oakandstoneremodel.com' 
      : 'http://localhost:8888';
    
    const response = await fetch(`${baseUrl}/.netlify/functions/update-sitemap`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const result = await response.json();
    
    if (result.success) {
      console.log('Sitemap updated successfully');
      return true;
    } else {
      console.error('Failed to update sitemap:', result.error);
      return false;
    }
  } catch (error) {
    console.error('Error updating sitemap:', error);
    return false;
  }
};
